import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;

  .custom-model-viewer {
    width: 600px;
    height: 400px;
  }
`;

export const Video = styled.video`
  width: 700px;
`;
